import { z } from 'zod';

export const dropStatusEventSchema = z.object({
  dropId: z.string(),
  status: z.string(),
  timestamp: z.string(),
  endTime: z.string().optional(),
});

export type DropStatusEvent = z.infer<typeof dropStatusEventSchema>;
